const locale = {
  'shoppingCart.title.shoppingCart': 'عربة التسوق',
  'shoppingCart.text.total': 'الإجمالي:',
  'shoppingCart.text.totalContent': '{total} وحدة SKU، إجمالي {totalCount} سلعة',
  'shoppingCart.button.deleteCommodity': 'حذف المنتجات',
  'shoppingCart.modal.deleteCommodity': `تحديد ما إذا كان حذف السلع المختارة`,
  'shoppingCart.button.clearQuantity': 'إعادة تعيين الكمية',
  'shoppingCart.modal.clearQuantity': 'هل أنت متأكد من إعادة تعيين كمية المنتجات المحددة؟',
  'shoppingCart.button.exportSelected': 'تصدير المحدد',
  'shoppingCart.notification.export.message': 'تم تصدير السلع المحددة',
  'shoppingCart.notification.export.description': 'يمكنك الاطلاع عليها في تنزيلات المتصفح',
  'shoppingCart.import.rule1': '1. يدعم فقط استيراد ملفات xlsx',
  'shoppingCart.import.rule2':
    '2. يمكنك الرجوع إلى الجدول أدناه لقائمة التحديث. الأعمدة التي تحمل علامة * مطلوبة',
  'shoppingCart.import.rule3': '3. بعد التأكيد، سيتم تحديث الكمية لأرقام القطع الموجودة',
  'shoppingCart.button.batchUpdateQuantity': 'تحديث الكمية دفعة واحدة',
  'shoppingCart.message.emptyCart': 'عربة التسوق فارغة، لا يمكن التحديث دفعة واحدة.',
  'shoppingCart.message.emptyUpdateData': 'لا توجد بيانات للتحديث، لا يمكن التحديث دفعة واحدة.',
  'shoppingCart.import.partNumber': 'رقم القطعة',
  'shoppingCart.import.brand': 'العلامة التجارية',
  'shoppingCart.import.quantity': 'الكمية',
  'shoppingCart.message.invalidCheckedCartItems':
    'بعض كميات البضائع لا تفي بالمتطلبات، يرجى التأكد',
  'shoppingCart.message.differentStoreCartItems': 'يمكنك التحقق من أي متجر واحد في كل مرة',
};

export default locale;
